angular.module('rental')
    .component('rentalResourceShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/rental/resource/show.html',
        controller: function ($scope, $state, $window, RentalResourceConst, Principal) {
            this.$onInit = () => {
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
            }

            this.cancel = () => {
                if ($window.history.length > 2)
                    $window.history.back();
                else {
                    $state.go('home');
                }
            }

            $scope.$on(RentalResourceConst.eventUpdate, () => $state.reload());
            $scope.$on(RentalResourceConst.eventDelete, () => this.cancel());
        }
    })
